'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var validators = require('../../validation/validators.js');

// from https://howtodoinjava.com/regex/canada-postal-code-validation/
var CA_ZIP_REGEX = new RegExp('^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$');
var US_ZIP_REGEX = new RegExp('^[0-9]{5}(?:-[0-9]{4})?$');
var getZipCodeNumeric = function (messageFragment) { return function (zipCode) {
    if (!zipCode || !zipCode.length) {
        return { error: false };
    }
    if (!US_ZIP_REGEX.test(zipCode) && !CA_ZIP_REGEX.test(zipCode)) {
        return {
            error: true,
            messageFragment: messageFragment,
        };
    }
    return { error: false };
}; };
var getAllValidators = function (fm) {
    var fmBase = 'componentLib.addressInput';
    var getIsPresent = function (fieldName) {
        return validators.isPresentGenerator(fm({ id: fmBase + ".validation." + fieldName }));
    };
    return {
        address1: [getIsPresent('address1')],
        city: [getIsPresent('city')],
        state: [validators.isSelectedGenerator(fm({ id: fmBase + ".validation.state" }))],
        zipCode: [
            getIsPresent('zipCode'),
            getZipCodeNumeric(fm({ id: fmBase + ".validation.zipCode" })),
        ],
    };
};
/*
 * The purpose of this method is just to say if any part of the address has an error. It is
 * intended for use to decide if the save button on a form that uses AddressInputWithValidation
 * should be enabled or disabled.
 */
var addressValidator = function (address, fm) { return tslib.__awaiter(void 0, void 0, void 0, function () {
    var allValidators, anyAddressErrorPromises, resolvedErrors, anyAddressErrors;
    return tslib.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                allValidators = getAllValidators(fm);
                anyAddressErrorPromises = tslib.__spreadArrays(allValidators.address1.map(function (validator) { return validator(address.address1, fm); }), allValidators.city.map(function (validator) { return validator(address.city, fm); }), allValidators.state.map(function (validator) { return validator(address.state, fm); }), allValidators.zipCode.map(function (validator) { return validator(address.zipCode, fm); }));
                return [4 /*yield*/, Promise.all(anyAddressErrorPromises)];
            case 1:
                resolvedErrors = _a.sent();
                anyAddressErrors = resolvedErrors.some(function (result) { return result.error; });
                if (anyAddressErrors)
                    return [2 /*return*/, { error: true }];
                return [2 /*return*/, { error: false }];
        }
    });
}); };

exports.addressValidator = addressValidator;
exports.getAllValidators = getAllValidators;
exports.getZipCodeNumeric = getZipCodeNumeric;
